import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-coinflip-coin',
  templateUrl: './coinflip-coin.component.html',
  styleUrls: ['./coinflip-coin.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoinflipCoinComponent {
  readonly side = input<number | string>(1);
  constructor() {}
}
